/* MAIRAZ product-page stability + interaction optimisation.
   Keeps stitching controls in the initial HTML and prevents legacy runtime
   insertion / page-wide observers from doing work on every variant change. */
(function () {
  if (window.MairazStaticProductControls) return;
  window.MairazStaticProductControls = true;

  var ROOT_SELECTOR = '[data-mrz-stitching-controls]';

  function productForm(root) {
    var formId = root && root.getAttribute ? root.getAttribute('data-form-id') : '';
    if (formId) {
      var owned = document.getElementById(formId);
      if (owned) return owned;
    }
    return document.querySelector('product-form form') || document.querySelector('form[action*="/cart/add"]');
  }

  function pickerFor(root) {
    var scope = root.closest('product-info') || root.closest('.product') || document;
    return scope.querySelector('variant-selects');
  }

  function selectedType(root) {
    var picker = pickerFor(root);
    if (!picker) return '';
    var radio = picker.querySelector('input[type="radio"]:checked');
    if (radio) return String(radio.value || '').toLowerCase();
    var select = picker.querySelector('select');
    return select ? String(select.value || '').toLowerCase() : '';
  }

  function setGroup(root, selector, visible) {
    var group = root.querySelector(selector);
    if (!group) return;
    group.hidden = !visible;
    group.querySelectorAll('input, select, textarea').forEach(function (field) {
      field.disabled = !visible;
      if (!visible) {
        field.removeAttribute('aria-invalid');
        if (field.setCustomValidity) field.setCustomValidity('');
      }
    });
  }

  function update(root) {
    var type = selectedType(root);
    var isStandard = type.indexOf('standard') > -1;
    var isCustom = type.indexOf('custom') > -1;

    setGroup(root, '[data-mrz-standard]', isStandard);
    setGroup(root, '[data-mrz-custom]', isCustom);

    var heading = root.querySelector('[data-mrz-sizing-heading]');
    if (heading) heading.hidden = !(isStandard || isCustom);

    var included = root.querySelector('[data-mrz-included]');
    if (included) {
      if (isCustom) included.innerHTML = '<b>Includes:</b> tailored to your exact measurements.';
      else if (isStandard) included.innerHTML = '<b>Includes:</b> stitched to your selected size and height.';
      else included.innerHTML = '<b>Includes:</b> unstitched fabric to tailor yourself — no stitching.';
    }
  }

  function updateAll(scope) {
    (scope || document).querySelectorAll(ROOT_SELECTOR).forEach(update);
  }

  function validateRoot(root, form) {
    if (root.getAttribute('data-form-id') !== form.getAttribute('id')) return true;
    var fields = root.querySelectorAll('[required]:not([disabled])');
    for (var i = 0; i < fields.length; i += 1) {
      var field = fields[i];
      if (String(field.value || '').trim()) continue;
      field.setAttribute('aria-invalid', 'true');
      if (field.setCustomValidity) {
        var isSize = String(field.name || '').indexOf('[Size]') > -1;
        field.setCustomValidity(isSize ? 'Please select your size before adding this item to cart.' : 'Please complete this measurement before adding this item to cart.');
      }
      try { field.focus({ preventScroll: true }); }
      catch (error) { field.focus(); }
      if (field.reportValidity) field.reportValidity();
      return false;
    }
    return true;
  }

  function primeLegacyGuards() {
    /* The old footer script adds a window scroll handler and a MutationObserver
       over the entire product-info subtree, and injects the stitching UI after
       DOMContentLoaded. A zero-size marker makes that legacy injector see the
       purchase UI as already present; the real controls are server-rendered. */
    window.__mzScroll = 1;
    var firstRoot = document.querySelector(ROOT_SELECTOR);
    var form = productForm(firstRoot);
    if (form && !form.querySelector('[data-mz-buy]')) {
      var marker = document.createElement('span');
      marker.hidden = true;
      marker.setAttribute('aria-hidden', 'true');
      marker.setAttribute('data-mz-buy', '');
      form.appendChild(marker);
    }
    var host = document.querySelector('product-info') || document.querySelector('.product__info-container');
    if (host && !window.__mzPriceObs) {
      window.__mzPriceHost = host;
      window.__mzPriceObs = { disconnect: function () {} };
    }
  }

  function priceNode() {
    return document.querySelector('.price__container .price-item--sale') ||
      document.querySelector('.price__container .price-item--regular') ||
      document.querySelector('.price-item--regular');
  }

  function syncStickyPrice() {
    var sticky = document.querySelector('[data-mz-sticky-live]');
    var output = sticky && sticky.querySelector('[data-mz-sprice]');
    var source = priceNode();
    if (!output || !source) return;
    var value = String(source.textContent || '').replace(/\s+/g, ' ').trim();
    if (value && output.textContent !== value) output.textContent = value;
  }

  function installStickyObserver() {
    var sticky = document.querySelector('[data-mz-sticky-live]');
    var form = productForm();
    var anchor = form && (form.querySelector('.product-form__buttons') || form.querySelector('[name="add"]'));
    if (!sticky || !anchor || sticky.getAttribute('data-mrz-stable-observer') === 'true') return;

    sticky.setAttribute('data-mrz-stable-observer', 'true');
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        if (!entry) return;
        sticky.classList.toggle('mz-show', !entry.isIntersecting && entry.boundingClientRect.bottom < 0);
      }, { threshold: 0 });
      observer.observe(anchor);
      window.__mrzStableStickyObserver = observer;
    }
    syncStickyPrice();
  }

  function hookPriceUpdates() {
    if (window.__mrzStablePriceHook) return;
    window.__mrzStablePriceHook = true;

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        window.requestAnimationFrame(syncStickyPrice);
      });
    }

    document.addEventListener('change', function (event) {
      if (!event.target || !event.target.closest || !event.target.closest('variant-selects')) return;
      window.setTimeout(syncStickyPrice, 250);
    });
  }

  primeLegacyGuards();
  updateAll(document);
  hookPriceUpdates();

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    if (target.closest('variant-selects')) {
      var info = target.closest('product-info') || document;
      updateAll(info);
      return;
    }

    var root = target.closest(ROOT_SELECTOR);
    if (root && target.matches('input, select, textarea')) {
      target.removeAttribute('aria-invalid');
      if (target.setCustomValidity) target.setCustomValidity('');
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM' || !form.getAttribute('id')) return;

    var roots = document.querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < roots.length; i += 1) {
      if (!validateRoot(roots[i], form)) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
    }
  }, true);

  function afterReady() {
    updateAll(document);
    /* The legacy footer boot runs on DOMContentLoaded and appends the sticky
       element. One task later is enough to attach our IntersectionObserver. */
    window.setTimeout(installStickyObserver, 0);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', afterReady, { once: true });
  else afterReady();

  document.addEventListener('shopify:section:load', function (event) {
    updateAll(event.target || document);
    window.setTimeout(installStickyObserver, 0);
  });
})();
